export type variant =
  'product-predefined' | 'serps-predefined' | 'serps' | 'product';

export interface RewardsWeekBannerProps {
  saving?: number;
  variant?: variant;
}

export interface RewardsWeekBannerLink {
  variant?: variant;
}

const RewardsWeekBanner = ({ saving, variant }: RewardsWeekBannerProps) => {
  const BannerCopy = ({ saving, variant }: RewardsWeekBannerProps) => {
    switch (variant) {
      case 'product-predefined':
        return (
          <>
            Save <span className="ch-color--ac-yellow">£{saving}</span> when you
            buy this car!
          </>
        );

      case 'serps-predefined':
        return (
          <>
            These cars are reduced by{' '}
            <span className="ch-color--ac-yellow">£500!</span>
          </>
        );

      default:
        return (
          <>
            Save <span className="ch-color--ac-yellow">£500</span> on thousands
            of cars!
          </>
        );
    }
  };

  const BannerLink = ({ variant }: RewardsWeekBannerLink) => {
    if (variant !== 'serps') return null;

    return (
      <div className="ch-mt--1 md:ch-display--inline md:ch-mt--0 md:ch-ml--1">
        <a
          className="ac-promo__link ch-color--white ch-fw--400 sm:ch-fs--3 ch-pa--0"
          href="/vehicles?promotion=true"
        >
          Shop deals
        </a>
      </div>
    );
  };

  return (
    <>
      <div className="ac-promo rewards-week-banner ch-justify-content--between ch-align-items--start">
        <div className="ch-color--white ch-fw--500 ch-fs--3 sm:ch-fs--4 ch-text--balance">
          <BannerCopy saving={saving} variant={variant} />
          <BannerLink variant={variant} />
        </div>
        <img
          alt="Rewards Event"
          className="ac-promo__image ch-ml--2"
          height="40"
          width="123"
        />
      </div>
    </>
  );
};

export default RewardsWeekBanner;
